<template>
  <panel title="采购统计" :infoContents="infoContents" class="mgb10">
    <vxe-table
      :data="records"
      border
      size="small"
      :loading="loading"
      class="border-inner-top"
      auto-resize
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="supplierName" title="供应商"></vxe-table-column>
      <vxe-table-column
        field="todayPurchaseQty"
        title="今天采购量"
      ></vxe-table-column>
      <vxe-table-column
        field="todayPurchaseAmount"
        title="今天采购额"
      ></vxe-table-column>
      <vxe-table-column
        field="todayReceiveQty"
        title="今天收货量"
      ></vxe-table-column>
      <vxe-table-column
        field="monthPurchaseQty"
        title="本月采购量"
      ></vxe-table-column>
      <vxe-table-column
        field="monthPurchaseAmount"
        title="本月采购额"
      ></vxe-table-column>
      <vxe-table-column
        field="monthReceiveQty"
        title="本月收货量"
      ></vxe-table-column>
      <vxe-table-column field="monthPercent" title="本月准交率">
        <template v-slot="{ row }"> {{ row.monthTimelyRate }}% </template>
      </vxe-table-column>
      <vxe-table-column field="MonthLeadTime" title="本月平均交货周期">
        <template v-slot="{ row }"> {{ row.monthLeadTime }} </template>
      </vxe-table-column>
    </vxe-table>
  </panel>
</template>

<script>
import Purchase from "@/api/purchase.js";
import Util from "@/utils";

export default {
  data() {
    return {
      Util: Util,
      loading: false,
      records: [],
      infoContents: [
        "采购量：以采购单的创建日期统计 采购单的数量和",
        "采购额：以采购单的创建日期统计 采购单价*数量 和",
        "收货量：以收货记录的收货日期统计 类型为采购的收货数量和",
        "本月准交率：以采购单的交货日期统计 当月准时交货的数量/当月应交货的数量",
        "本月平均交货周期：（采购单的收货完成日期-采购单下单日期）的天数和 / 当月交货完成的单数",
      ],
    };
  },
  created() {
    const self = this;
    self.loading = true;
    Purchase.purchaseQtyCount().then(function (res) {
      if (res.status == 200) {
        self.records = res.data;
      } else {
        self.sysError();
      }
      self.loading = false;
    });
  },
};
</script>